module.exports = __webpack_public_path__ + "img/fb.f8893189.png";